import RentalscapeLogo from '@/../favicon-apple-touch-144.png';
import { routes } from '@/app/routes';
import { cityDisplayName, rentalscapeStats } from '@/data/data-selectors';
import { UserPlaceSwitcher } from '@/user/user-placer-switcher/user-place-switcher';
import useRegion from '@/utils/hooks/useRegion';
import { usePlaceSpecificUrlFactory } from '@/utils/place-detection';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Avatar } from '../avatar';
import { DeckardSupport } from '../modules/deckard-support';
import { UniversalSearch } from '../universal-search';
import {
  BottomHalf,
  StyledRentalscapeLogo,
  TopHalf,
  VerticalNav,
  Wrapper,
} from '../vertical-bar-styles';
import { ComplaintsNavItem } from './nav-items/complaints';
import { DashboardNavItem } from './nav-items/dashboard';
import { HelpSupportNavItem } from './nav-items/help-support';
import { ListNavItem } from './nav-items/list';
import { MapNavItem } from './nav-items/map';
import { TaxNavItem } from './nav-items/tax';
import { VerticalBarSkeleton } from './vertical-bar-skeleton';

export function VerticalBar() {
  const history = useHistory();

  const rentalscapeStatsObj = useSelector(rentalscapeStats);
  const cityName = useSelector(cityDisplayName);

  const [showPlaceSwitcher, setShowPlaceSwitcher] = useState(false);

  const getPlaceSpecificUrl = usePlaceSpecificUrlFactory();

  const { region } = useRegion();

  // We have to wait to be redirected to right url sometimes, so we show a skeleton in that case
  if (!region) {
    return <VerticalBarSkeleton />;
  }

  return (
    <Wrapper className="hidden-on-print">
      <TopHalf>
        <StyledRentalscapeLogo>
          <img
            alt="Rentalscape"
            data-cy="rentalscape-logo"
            data-testid="rentalscape-logo"
            src={RentalscapeLogo}
          />
        </StyledRentalscapeLogo>

        <VerticalNav aria-label="Navigation menu" role="navigation">
          <MapNavItem />
          <ListNavItem />
          <TaxNavItem />
          <ComplaintsNavItem />
          <HelpSupportNavItem />
          <DashboardNavItem />
        </VerticalNav>
      </TopHalf>

      <BottomHalf>
        <UniversalSearch />
        <DeckardSupport />
        <Avatar
          src={rentalscapeStatsObj?.logo}
          cityName={cityName}
          onLogoutClick={() => {
            history.push(routes.LOGOUT);
          }}
          onProfileClick={() =>
            history.push(getPlaceSpecificUrl(routes.PROFILE))
          }
          onLegalClick={() => {
            history.push(getPlaceSpecificUrl(routes.LEGAL));
          }}
          onChangeCityClick={() => setShowPlaceSwitcher(true)}
        />
        <UserPlaceSwitcher
          open={showPlaceSwitcher}
          setOpen={setShowPlaceSwitcher}
        />
      </BottomHalf>
    </Wrapper>
  );
}
